var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.1 21.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n        stroke-width: 0px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.47,
    y1: 20.2,
    x2: 2.91,
    y2: 1.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30bde3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a926e8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.06,13.24c-.65.75-1.27,1.47-1.89,2.19-1.68,1.96-3.37,3.91-5.04,5.87-.18.21-.35.32-.64.3-.46-.03-.92,0-1.44,0,.08-.11.12-.18.17-.24,2.6-3.02,5.2-6.05,7.8-9.06.18-.21.18-.33.03-.56C5.42,7.93,2.8,4.12.18.3c-.05-.08-.1-.16-.18-.28C.13.02.22,0,.32,0c1.88,0,3.76,0,5.65,0,.23,0,.36.07.48.26,1.69,2.48,3.39,4.95,5.09,7.42.06.08.11.16.2.27.22-.25.42-.48.62-.71,2.01-2.33,4.02-4.67,6.02-7,.14-.17.28-.24.51-.24.49.02.99,0,1.56,0-.49.58-.94,1.09-1.38,1.61-2.09,2.43-4.19,4.87-6.29,7.3-.17.2-.17.32-.02.53,2.74,3.97,5.47,7.95,8.21,11.93.04.05.07.11.14.22h-.39c-1.83,0-3.65,0-5.48,0-.32,0-.49-.1-.66-.36-1.78-2.61-3.57-5.2-5.36-7.8-.04-.05-.08-.11-.15-.21ZM2.51,1.41c.11.16.17.25.23.34,1.39,1.99,2.78,3.97,4.17,5.96,2.89,4.13,5.77,8.26,8.66,12.38.07.1.22.19.34.19.82.02,1.64,0,2.46,0,.05,0,.09-.02.16-.04-.07-.11-.12-.19-.18-.27-2.85-4.07-5.7-8.15-8.54-12.22-1.42-2.03-2.84-4.06-4.27-6.09-.07-.1-.19-.24-.28-.24-.89-.02-1.78-.01-2.75-.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGradient);
export default __webpack_public_path__ + "static/media/twitter-gradient.9f4fc143c594ff5f37101d9b49f3637a.svg";
export { ForwardRef as ReactComponent };